import { isBrowser } from '../../env'
import { EventManager } from '../event-manager.class'
import { PIPE } from './pipe'

const connectors = {}

export const getConnector = (pipePath) => {
  if (!pipePath || isBrowser()) {
    return {}
  }

  if (!connectors[pipePath]) {
    try {
      const events = new EventManager()
      const pipe = new PIPE(pipePath)
      const connector = pipe.createConnection({
        onEvent: (response) => {
          events.dispatch(response._to, response)
          events.dispatch('*', response)
        },
      })
      connectors[pipePath] = {
        pipe,
        connector,
        events
      }
    } catch (e) {
      console.error(e)
      return {}
    }
  }

  const ipcEndPoint = connectors[pipePath]
  const ipcConnector = ipcEndPoint.connector
  const listener = ipcEndPoint.events
  const request = (to, action, data, from = '_inface', sync = false) => {
    const requestPayload = {
      _to: to || '_inface',
      _action: action || 'UNKNOWN_ACTION',
      _from: from || '_inface',
      _req_id: +new Date(),
      _sync: sync || false,
      _data: data || {},
    }
    ipcConnector.send(requestPayload)
    return requestPayload._req_id
  }

  return {
    request,
    listener
  }
}


export default {
  getConnector
}


